import Button from '@material-ui/core/Button'
import { useEffect, useState } from "react";
import moment from 'moment'
import { useDispatch, useSelector } from "react-redux";
import { getPrnInquireDataAction } from '../../../../redux/modules/SSSPRN/prnInquire';
import CircularProgress from '@material-ui/core/CircularProgress';

const SSSInquirePRN = ({ validTransactions, data, transaction, styles, classes, inquireError, billerTransactions, updateBillerTxn, ongoingTransactionInput }) => {
    const { prnInquireData, error } = useSelector((state) => state.prnInquire);
    let dispatch = useDispatch();
    const [buttonDisabled, setButtonDisabled] = useState(true);
    const [loading, setLoading] = useState(false);
    const [reInquire, setReInquire] = useState(false);
    const [transactionKey, setTransactionKey] = useState(null);

    useEffect(()=>{
        setButtonDisabled(checkReferenceHasDuplicate(transaction) || !checkReferenceAndAmount(transaction))
    },[transaction, billerTransactions])

    // useEffect(()=>{
    //     setLoading(isLoading)
    // },[isLoading])

    useEffect(()=>{
        if(prnInquireData && transaction.referenceNumber === prnInquireData.details.prn){
            setPRNInquireData(prnInquireData)
            setReInquire(true)
            setLoading(false)
        }
    },[prnInquireData])

    useEffect(()=>{
        if (
            error &&
            checkReferenceAndAmount(transaction) &&
            error.requestBody?.transactionKey === transaction.transactionKey
        ) {
            inquireError(error, transaction);
            setReInquire(false);
            setLoading(false);
        }
    },[error, transaction.transactionKey, transaction.referenceNumber]);

    const checkReferenceAndAmount = (transaction) =>{
        let isValid = false;
        if(transaction.referenceNumber && transaction.referenceNumber.length == 14 && transaction.amount) {
            isValid = true
        }else{
            setReInquire(false)
        }
        return (isValid)
    }


    const checkReferenceHasDuplicate = (transaction) =>{
        const SSSInquiryList = Array.isArray(billerTransactions.SSSNW) ? billerTransactions.SSSNW : [];
        let isDuplicate = false;
        if (SSSInquiryList.length > 0 && transaction.referenceNumber.length == 14) {
            const count = SSSInquiryList.reduce((acc, item) => {
                if (item && item.referenceNumber === transaction.referenceNumber) return acc + 1;
                return acc;
            }, 0);

            // mark as duplicate when occurrences are greater than 1
            if (count > 1) isDuplicate = true;
        }
        if (isDuplicate) {
            if(ongoingTransactionInput.transactionKey === transaction.transactionKey){
                const errorResult = {
                    errorCode: "API3_ERROR_SSS_PRN_DUPLICATE",
                    errorMessage: "Oops, this PRN is already input in another field.",
                    errorStatusCode: 400,
                    requestBody: transaction,
                    errorFieldKey : "referenceNumber"
                }
                inquireError(errorResult, transaction)
            }
        }else{
            inquireError(null, transaction)
        }
        return (isDuplicate)
    }

    const inquirePRN = () =>{
        setLoading(true)
        updateBillerTxn({
            code: data.code,
            txnKey: transaction.transactionKey,
            key: "payeeName",
            value: "DELETE_KEY",
        })
        updateBillerTxn({
            code: data.code,
            txnKey: transaction.transactionKey,
            key: "invoiceNum",
            value: "DELETE_KEY",
        })
        updateBillerTxn({
            code: data.code,
            txnKey: transaction.transactionKey,
            key: "applDtFr",
            value: "DELETE_KEY",
        })
        updateBillerTxn({
            code: data.code,
            txnKey: transaction.transactionKey,
            key: "applDtTo",
            value: "DELETE_KEY",
        })
        updateBillerTxn({
            code: data.code,
            txnKey: transaction.transactionKey,
            key: "payType",
            value: "DELETE_KEY",
        })
        updateBillerTxn({
            code: data.code,
            txnKey: transaction.transactionKey,
            key: "isPRNInquired",
            value: "DELETE_KEY",
        })
        const payload = {code : data.code, referenceNumber : transaction.referenceNumber, amount : transaction.amount, otherCharges : transaction.otherCharges, paymentMethod : "CASH", transactionKey: transaction.transactionKey}
        inquireError(null, transaction)
        setTransactionKey(transaction.transactionKey)
        dispatch(getPrnInquireDataAction(payload))
    }

    const setPRNInquireData = (prnInquireData) =>{
        if(prnInquireData) {
            updateBillerTxn({
                code: data.code,
                txnKey: transaction.transactionKey,
                key: "amount",
                value: transaction.amount,
            });
            updateBillerTxn({
                code: data.code,
                txnKey: transaction.transactionKey,
                key: "referenceNumber",
                value: prnInquireData.details.prn,
            })
            updateBillerTxn({
                code: data.code,
                txnKey: transaction.transactionKey,
                key: "payeeName",
                value: prnInquireData.details.payeeName,
            })
            updateBillerTxn({
                code: data.code,
                txnKey: transaction.transactionKey,
                key: "invoiceNum",
                value: prnInquireData.details.invoiceNum,
            })
            updateBillerTxn({
                code: data.code,
                txnKey: transaction.transactionKey,
                key: "applDtFr",
                value: prnInquireData.details.applDtFr,
            })
            updateBillerTxn({
                code: data.code,
                txnKey: transaction.transactionKey,
                key: "applDtTo",
                value: prnInquireData.details.applDtTo,
            })
            updateBillerTxn({
                code: data.code,
                txnKey: transaction.transactionKey,
                key: "payType",
                value: prnInquireData.details.payType,
            })
            updateBillerTxn({
                code: data.code,
                txnKey: transaction.transactionKey,
                key: "isPRNInquired",
                value: true,
            })
        }
    }

    return (
        <>
            <Button 
                variant="contained" 
                id="inquirePRN" 
                color="inherit" 
                size="medium"
                style={{
                    backgroundColor: buttonDisabled || loading ? "#7097bd" : "#0075bd",
                }}
                disabled={buttonDisabled || loading} 
                className={classes.inquirePRNbtn} 
                onClick={inquirePRN}>
                    {loading && transactionKey === transaction.transactionKey ? <CircularProgress size={21} style={{color: "#CED4DA", marginLeft: 2}} /> : transaction.isPRNInquired ? "Re-Inquire" : "Inquire"}
            </Button>
        </>
    )
}

export default SSSInquirePRN